import Vue from 'vue';
import { DEBUG_MODE } from '@app/store';
export default {
    state: function (state, moduleName) {
        if (moduleName === void 0) { moduleName = null; }
        var reactiveState = Vue.observable(state);
        if (process.env.NODE_ENV != "production" && DEBUG_MODE) {
            new Vue({
                created: function () {
                    var _this = this;
                    Object.keys(reactiveState).forEach(function (key) {
                        _this.$watch(function () { return reactiveState[key]; }, function (value) {
                            if (moduleName) {
                                console.log("\uD83D\uDD38 " + moduleName + " state changed: " + key, value);
                            }
                            else {
                                console.log("\uD83D\uDD39 Root state changed: " + key, value);
                            }
                        });
                    });
                }
            });
        }
        return reactiveState;
    }
};
